export default __webpack_public_path__ + "static/media/IconDesc_C_Inv_Ramp_8x2_02.256.affa6135.png";